import React, { FC } from 'react';
import cn from 'classnames';
require("../Rating.css");
var stylesRating = {
  "Rating": "Rating-module-Rating_2LC",
  "sSize": "Rating-module-sSize_2yq",
  "Star": "Rating-module-Star_BF2",
  "mSize": "Rating-module-mSize_3vQ",
  "lSize": "Rating-module-lSize_21k"
};
require("./RatingStar.css");
var styles = {
  "Star": "RatingStar-module-Star_RzD",
  "fullVariant": "RatingStar-module-fullVariant_2px",
  "emptyVariant": "RatingStar-module-emptyVariant_13q"
};
const prettyWidth = float => Number(((float > 0 ? Math.asin(2 * float - 1) / Math.PI + 0.5 : 0) * 100).toFixed(1));
export const RatingStar = ({
  fullness
}) => {
  const fullnessWidth = {
    width: prettyWidth(fullness) + '%'
  };
  const variant = fullness === 1 ? 'full' : 'empty';
  return fullness > 0 && fullness < 1 ? /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: cn(styles.Star, styles.emptyVariant, stylesRating.Star)
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: cn(styles.Star, styles.fullVariant, stylesRating.Star),
    style: fullnessWidth
  })) : /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: cn(styles.Star, styles[`${variant}Variant`], stylesRating.Star)
  });
};